/* 店铺管理 */

import { GET, POST } from '@/request/http'

export const storeTest = p => GET('/store/stores/{store_id}/{store_name}', p)

// 根据id查询店铺信息
export const storeGetStoreInfoById = p => GET('/store/stores/{store_id}', p)

// 根据id查询店铺信息
export const storeGetStoreList = p => GET('/store/stores', p)

// 店铺收款预下单
export const storeCollectionPreorders = p => POST('/store/collection/preorders', p)

// 查询店铺收款记录
export const storeCollectionPage = p => POST('/store/collection/page', p)

// 店铺余额充值
export const storeMemberBalanceRecharge = p => POST('/store/member-balance/recharge', p)

// 查询充值记录
export const storeMemberBalanceRechargeRecords = p => GET('/store/member-balance/recharge-records', p)

// 消费
export const storeMemberBalanceCharge = p => POST('/store/member-balance/charge', p)

// 查询用户店铺余额
export const storeGetMemberBalanceByPhone = p => GET('/store/member-balance/balance-infos/{member_phone}', p)

// 店铺余额付款
export const storeMemberBalancePay = p => POST('/store/memberbalance/pay', p)

// 查询当前用户所有店铺余额列表
export const storeGetMemberBalancePayListBySelf = p => POST('/store/memberbalance/list/bycurrentuser', p)

// 查询店铺余额充值记录
export const storeGetMemberBalanceRechargePage = p => POST('/store/memberbalance/recharge/page', p)

// 查询店铺收款记录
export const storeCollectionOrdersPage = p => GET('/store/collection-orders', p)



// WEBPACK FOOTER //
// ./src/api/modules/store.js